import React from 'react';
import { ConfigModulePage } from './modules/ConfigModulePage';
import { ContentModulePage } from './modules/ContentModulePage';
import { ImportExportPage, RequestsPage } from './modules/OpsModulePages';
import { ModuleShell } from './modules/ModuleShell';

export const AdminRequests = RequestsPage;
export const AdminImportExport = ImportExportPage;

export const AdminBlog = () => (
  <ContentModulePage kind="blog" title="Blog" itemLabel="artículo" description="Artículos y noticias de Zona Libre"
    note="Puedes crear y guardar artículos, pero todavía no se muestran en la tienda pública." />
);

export const AdminCMS = () => (
  <ContentModulePage kind="cms" title="CMS" itemLabel="página" description="Páginas de contenido: Términos, Privacidad, Acerca de…"
    note="Las páginas se guardan aquí, pero aún no reemplazan los textos del sitio público." />
);

export const AdminTaxes = () => (
  <ConfigModulePage module="taxes" title="Impuestos" description="Tasas de IVA y retenciones para vendedores"
    note="Los valores se guardan, pero todavía no se aplican al checkout ni a las facturas."
    fields={[
      { key: 'iva_pct', label: 'IVA (%)', type: 'number' },
      { key: 'isr_retention_pct', label: 'Retención ISR a vendedores (%)', type: 'number' },
      { key: 'iva_retention_pct', label: 'Retención IVA a vendedores (%)', type: 'number' },
      { key: 'prices_include_iva', label: 'Los precios publicados incluyen IVA', type: 'bool' },
      { key: 'rfc_required_for_sellers', label: 'Exigir RFC a los vendedores', type: 'bool' },
    ]} />
);

export const AdminShipping = () => (
  <ConfigModulePage module="shipping" title="Envíos y Recolecciones" description="Costos de envío nacional y entrega local"
    note="Los valores se guardan, pero el checkout todavía usa sus costos actuales."
    fields={[
      { key: 'national_flat_cost', label: 'Envío nacional fijo (MXN)', type: 'number' },
      { key: 'free_shipping_threshold', label: 'Envío gratis desde (MXN)', type: 'number' },
      { key: 'local_delivery_fee', label: 'Tarifa de entrega local (MXN)', type: 'number' },
      { key: 'max_local_radius_km', label: 'Radio máximo de entrega local (km)', type: 'number' },
      { key: 'default_carrier', label: 'Paquetería por defecto', type: 'text' },
    ]} />
);

export const AdminSettings = () => (
  <ConfigModulePage module="settings" title="Configuración General" description="Datos generales del sitio"
    note="Los datos se guardan, pero todavía no se muestran en el sitio ni activan el modo mantenimiento."
    fields={[
      { key: 'site_name', label: 'Nombre del sitio', type: 'text' },
      { key: 'support_email', label: 'Correo de soporte', type: 'text' },
      { key: 'support_phone', label: 'Teléfono de soporte', type: 'text' },
      { key: 'currency', label: 'Moneda', type: 'text' },
      { key: 'maintenance_mode', label: 'Modo mantenimiento', type: 'bool' },
    ]} />
);

export const AdminReports = () => (
  <ModuleShell title="Reportes" description="Reportes y análisis de ventas" note="Usa el War Room y Exportar CSV mientras tanto." testid="module-reports" />
);
